import { Pipe, PipeTransform } from '@angular/core';
import { TIC_NAME } from '@app/config/tic-name.enum';


@Pipe({
  name: 'ticName'
})
export class TicNamePipe implements PipeTransform {

  public dataSelectTic = TIC_NAME.map(b => { return b });

  transform(value: any): string {

    return this.dataSelectTic[this.dataSelectTic.findIndex(x => x.id === value)].name || ''
  }

}
